/**
 * @module Stock
 */

import Component from '../base/Component';
import './styles.css';
import '../../scripts/picture';

/**
 * Название компонента.
 */
export default class Stock extends Component {
    static className = 'stock';

    initElements() {
        this.elements = {};
    }

    init(options) {
        super.init(options);
    }
}
